var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsFileLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 206,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9217_87154)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9217_87154",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 206,
    height: 206
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206 0H0V206H206V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9217_87154)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9217_87154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.199 137.795L144.186 137.799L70.8504 157.461C68.2449 158.153 65.556 156.596 64.8576 153.991L64.854 153.978L37.7038 52.7153C37.0123 50.1097 38.5686 47.4208 41.1736 46.7224L41.1868 46.7188L91.318 33.2778L97.7392 57.2272C98.3273 59.4207 100.59 60.7267 102.784 60.1386L126.733 53.7174L147.669 131.802C148.36 134.408 146.804 137.097 144.199 137.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3037 47.2105C38.9667 47.8371 37.5704 50.2495 38.1905 52.5857L65.3442 153.862C65.9708 156.199 68.3832 157.595 70.7194 156.975L144.068 137.309C146.405 136.682 147.801 134.27 147.181 131.934L126.376 54.3362L102.914 60.6268C100.452 61.2869 97.9118 59.8209 97.2516 57.3588L90.9611 33.8966L41.3037 47.2105ZM41.0425 46.2363L91.6741 32.6612L98.2259 57.0976C98.7425 59.0246 100.726 60.1692 102.653 59.6526L127.089 53.1008L148.156 131.673C148.919 134.551 147.205 137.512 144.329 138.283L70.9806 157.949C68.1026 158.713 65.1411 156.999 64.37 154.123L37.2163 52.8469C36.4524 49.9689 38.1665 47.0074 41.0425 46.2363Z",
    fill: "#DADADC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0476 88.7986L69.5576 92.6836L77.3276 121.664L91.8176 117.779L84.0476 88.7986Z",
    fill: "#F0F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.802 80.3228L70.2639 91.4598C69.7303 91.6028 69.4138 92.1512 69.5569 92.6847L77.0679 120.699C77.2109 121.232 77.7593 121.549 78.2929 121.406L119.831 110.269C120.364 110.126 120.681 109.577 120.538 109.044L113.027 81.0298C112.884 80.4962 112.335 80.1797 111.802 80.3228Z",
    stroke: "#DADADC",
    strokeWidth: 2.00024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.065 88.5001L71.6289 100.414L72.1469 102.346L116.583 90.4321L116.065 88.5001Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.915 99.1251L74.4785 111.039L74.9965 112.971L119.433 101.057L118.915 99.1251Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5297 86.8687L81.5977 87.3867L90.1447 119.265L92.0767 118.747L83.5297 86.8687Z",
    fill: "#DADADC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.658 52.8338L101.911 59.2008C100.268 59.6412 98.574 58.6633 98.1337 57.0209L91.7666 33.2734L92.6032 33.0491L92.6161 33.0457C93.6709 32.7629 95.3618 32.9837 96.3083 33.5279L123.172 49.0504C124.116 49.5952 125.152 50.9445 125.434 51.9969L125.658 52.8338Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.046 52.4822L124.951 52.1284C124.702 51.2006 123.754 49.9657 122.922 49.4853L96.0593 33.9634C95.2245 33.4834 93.6761 33.2812 92.7458 33.5306L92.3793 33.6289L98.6169 56.8934C98.9858 58.2694 100.405 59.0887 101.781 58.7198L125.046 52.4822ZM126.271 53.1892L102.04 59.6858C100.13 60.1981 98.1632 59.0631 97.6509 57.1524L91.1543 32.9219L92.4868 32.5646C93.671 32.2471 95.4949 32.4853 96.5578 33.0964L123.422 48.6193C124.483 49.2312 125.6 50.6873 125.917 51.8694L126.271 53.1892Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9217_87154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.639 156.042H140.625H65.3481C62.6754 156.035 60.5 153.854 60.5 151.18V151.167V47.2231C60.5067 44.5504 62.6876 42.375 65.3614 42.375H65.375H116.833V66.9583C116.833 69.2099 118.665 71.0416 120.917 71.0416H145.5V151.193C145.493 153.866 143.312 156.042 140.639 156.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3614 42.875C62.9626 42.875 61.006 44.8267 61 47.2231V151.18C61 153.579 62.9517 155.536 65.3481 155.542H140.639C143.037 155.542 144.994 153.59 145 151.193V71.5416H120.917C118.389 71.5416 116.333 69.4856 116.333 66.9583V42.875H65.3614ZM65.3614 41.875H117.333V66.9583C117.333 68.9363 118.939 70.5416 120.917 70.5416H146V151.193C145.992 154.146 143.591 156.542 140.639 156.542H65.3481C62.396 156.534 60 154.132 60 151.18V47.2231C60.0074 44.271 62.4093 41.875 65.3614 41.875Z",
    fill: "#DADADC"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.653
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96 100H81V131H96V100Z",
    fill: "#F0F0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 89H82C81.4477 89 81 89.4477 81 90V130C81 130.552 81.4477 131 82 131H125C125.552 131 126 130.552 126 130V90C126 89.4477 125.552 89 125 89Z",
    stroke: "#DADADC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 109H81V111H127V109Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 98H81V100H127V98Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 120H81V122H127V120Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 99H94V132H96V99Z",
    fill: "#DADADC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.5 70.0416H120.916C119.216 70.0416 117.833 68.6585 117.833 66.9583V42.375H118.699H118.712C119.804 42.375 121.38 43.0261 122.153 43.7968L144.078 65.744C144.849 66.5146 145.5 68.0859 145.5 69.1754V70.0416Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145 69.5416V69.1754C145 68.215 144.404 66.7768 143.724 66.0974L121.8 44.151C121.118 43.4713 119.675 42.875 118.712 42.875H118.333V66.9583C118.333 68.3828 119.492 69.5416 120.916 69.5416H145ZM146 70.5416H120.916C118.938 70.5416 117.333 68.9363 117.333 66.9583V41.875H118.712C119.938 41.875 121.638 42.5773 122.506 43.4427L144.432 65.3906C145.297 66.256 146 67.9517 146 69.1754V70.5416Z",
    fill: "#DADADC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_9217_87154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.5 174C151.374 174 161 164.374 161 152.5C161 140.626 151.374 131 139.5 131C127.626 131 118 140.626 118 152.5C118 164.374 127.626 174 139.5 174Z",
    fill: "#8BB611"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.5 173.5C151.098 173.5 160.5 164.098 160.5 152.5C160.5 140.902 151.098 131.5 139.5 131.5C127.902 131.5 118.5 140.902 118.5 152.5C118.5 164.098 127.902 173.5 139.5 173.5Z",
    stroke: "black",
    strokeOpacity: 0.06
  })), /*#__PURE__*/React.createElement("path", {
    d: "M133.261 152.507C133.261 154.23 131.864 155.627 130.141 155.627C128.417 155.627 127.021 154.23 127.021 152.507C127.021 150.784 128.417 149.387 130.141 149.387C131.864 149.387 133.261 150.784 133.261 152.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.621 152.507C142.621 154.23 141.224 155.627 139.501 155.627C137.777 155.627 136.381 154.23 136.381 152.507C136.381 150.784 137.777 149.387 139.501 149.387C141.224 149.387 142.621 150.784 142.621 152.507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.981 152.507C151.981 154.23 150.584 155.627 148.861 155.627C147.137 155.627 145.741 154.23 145.741 152.507C145.741 150.784 147.137 149.387 148.861 149.387C150.584 149.387 151.981 150.784 151.981 152.507Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9217_87154",
    x: 31.008,
    y: 29.6471,
    width: 123.355,
    height: 137.525,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.01308
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.01308
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.059 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9217_87154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9217_87154",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9217_87154",
    x: 54,
    y: 38.875,
    width: 98,
    height: 126.668,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.059 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9217_87154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9217_87154",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_9217_87154",
    x: 112,
    y: 128,
    width: 55,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.266667 0 0 0 0 0.345098 0 0 0 0 0.0392157 0 0 0 0.149 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9217_87154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9217_87154",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9217_87154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 206,
    height: 206,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsFileLoading);
export default __webpack_public_path__ + "static/media/xls-file-loading.fbfce2b2c71c6d9c9d39f44a2f56fab8.svg";
export { ForwardRef as ReactComponent };